<div [formGroup]="form">
  <app-common-checkbox data-test-id="force-get-checkbox" [formControlName]="forceGetControlName">
    <span class="checkbox-label">{{ 'force_get' | translate }}</span>
  </app-common-checkbox>
</div>
